<template>
  <div class="wrapper">
    <div class="title">
      Customer Bookings
      <b-tooltip
        position="is-top"
        label="Green means more than last week and also more than 49%, amber is more than last week but below 50% or more than 50% but less than last week and red is less than 50% and last week"
        :append-to-body="true"
        multilined
        ><b-icon icon="help"></b-icon
      ></b-tooltip>
    </div>
    <b-table :data="this.tableData" sticky-header :loading="loading" default-sort="difference">
      <b-table-column field="name" label="Name" v-slot="props" sortable>
        <router-link :to="'/voiceplus/dashboard/' + props.row.disctools_id">{{ props.row.name }}</router-link></b-table-column
      >
      <b-table-column v-if="mode != 'historic'" field="mostRecent.booked" centered label="Last hour" v-slot="props" sortable>{{ props.row.mostRecent.booked }}</b-table-column>
      <b-table-column
        v-if="mode != 'historic'"
        field="mostRecent.conversionrate"
        centered
        label="Conversion Rate"
        :td-attrs="(row) => ({ class: GetClassColour(row.mostRecent.conversionrate, row.mostRecentLastWeek.conversionrate) })"
        v-slot="props"
        sortable
        ><span v-if="props.row.mostRecent.fullybooked > 0" class="littleBox"
          >{{ parseInt(props.row.mostRecent.conversionrate) }}% <b-tooltip :label="props.row.mostRecent.fullybooked + '% Fully Booked'"><div style="cursor: pointer">*</div></b-tooltip></span
        >
        <span v-else class="littleBox">{{ parseInt(props.row.mostRecent.conversionrate) }}%</span></b-table-column
      >
      <b-table-column v-if="mode != 'historic'" field="mostRecentLastWeek.booked" centered label="Last hour last week" v-slot="props" sortable>{{
        props.row.mostRecentLastWeek.booked
      }}</b-table-column>
      <b-table-column
        v-if="mode != 'historic'"
        field="mostRecentLastWeek.conversionrate"
        label="Conversion Rate"
        centered
        :td-attrs="(row) => ({ class: row.mostRecentLastWeek.conversionrate > 50 ? 'green' : 'red' })"
        v-slot="props"
        sortable
        ><span v-if="props.row.mostRecentLastWeek.fullybooked > 0" class="littleBox"
          >{{ props.row.mostRecentLastWeek.conversionrate }}% <b-tooltip :label="props.row.mostRecentLastWeek.fullybooked + '% Fully Booked'"><div style="cursor: pointer">*</div></b-tooltip></span
        ><span v-else class="littleBox">{{ props.row.mostRecentLastWeek.conversionrate }}%</span></b-table-column
      >
      <b-table-column field="today.booked" centered label="Day" v-slot="props" sortable>{{ props.row.today.booked }}</b-table-column>
      <b-table-column field="today.conversionrate" centered label="Conversion Rate" v-slot="props" :td-attrs="(row) => ({ class: row.today.conversionrate > 50 ? 'green' : 'red' })" sortable
        ><span v-if="props.row.today.fullybooked > 0" class="littleBox"
          >{{ props.row.today.conversionrate }}% <b-tooltip :label="props.row.today.fullybooked + '% Fully Booked'"><div style="cursor: pointer">*</div></b-tooltip></span
        >
        <span v-else class="littleBox">{{ props.row.today.conversionrate }}%</span></b-table-column
      >
    </b-table>
  </div>
</template>

<script>
const dayjs = require("dayjs");
export default {
  components: {},
  props: {
    stats: {
      type: Object,
      required: true,
    },
    customers: {
      type: Array,
      required: true,
    },
    selectedDate: {
      type: Date,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      tableData: [],
      loading: true,
      formattedSelectedDate: dayjs(this.selectedDate),
    };
  },
  methods: {
    CalculateTableStats: async function () {
      let today = this.stats[this.formattedSelectedDate.format("DD-MM-YYYY")];
      let yesterday = this.stats[dayjs(this.selectedDate).subtract(1, "day").format("DD-MM-YYYY")];
      //console.log(yesterday);
      let thisDayLastWeek = this.stats[dayjs(this.selectedDate).subtract(7, "day").format("DD-MM-YYYY")];
      //console.log(thisDayLastWeek);
      let thisHourLastWeek = thisDayLastWeek[Object.keys(today)[Object.keys(today).length - 1]];
      let mostRecent = today[Object.keys(today)[Object.keys(today).length - 1]];
      let hourBefore = {};
      if (today.length < 2) {
        //New day
        hourBefore = yesterday[Object.keys(today)[Object.keys(today).length - 1]];
      } else {
        hourBefore = today[Object.keys(today)[Object.keys(today).length - 2]];
      }
      const dataObj = { mostRecent: {}, mostRecentLastWeek: {} };

      //mostRecent hour
      for (const [customerId, customerData] of Object.entries(mostRecent)) {
        let foundCustomer = this.customers.find((customerSearch) => {
          return customerSearch.disctools_id == customerId;
        });
        if (foundCustomer === undefined || foundCustomer.type == "dev" || foundCustomer.type == "demo") {
          continue;
        }
        let customerInfo = this.CalculateHourStats(customerData);
        dataObj.mostRecent[customerId] = customerInfo;
      }

      //mostRecent hour but last week
      for (const [customerId, customerData] of Object.entries(thisHourLastWeek)) {
        let foundCustomer = this.customers.find((customerSearch) => {
          return customerSearch.disctools_id == customerId;
        });
        if (foundCustomer === undefined || foundCustomer.type == "dev" || foundCustomer.type == "demo") {
          continue;
        }
        let customerInfo = this.CalculateHourStats(customerData);
        dataObj.mostRecentLastWeek[customerId] = customerInfo;
      }

      //todaySoFar
      const customerTodayData = {};
      for (const [time, timeData] of Object.entries(today)) {
        for (const [customerId, customerData] of Object.entries(timeData)) {
          let foundCustomer = this.customers.find((customerSearch) => {
            return customerSearch.disctools_id == customerId;
          });
          if (foundCustomer === undefined || foundCustomer.type == "dev" || foundCustomer.type == "demo") {
            continue;
          }
          let hourStats = this.CalculateHourStats(customerData);
          if (customerTodayData[customerId] == undefined) {
            customerTodayData[customerId] = { totalcalls: 0, booked: 0, fullybooked: 0 };
          }
          if (hourStats.bookablesessions == 0) continue;
          customerTodayData[customerId].totalcalls += hourStats.bookablesessions;
          customerTodayData[customerId].booked += hourStats.booked;
          customerTodayData[customerId].fullybooked += hourStats.fullybooked;
        }
      }

      for (const [customerId, customerData] of Object.entries(customerTodayData)) {
        customerData.conversionrate = customerData.totalcalls > 0 ? parseInt((customerData.booked / customerData.totalcalls) * 100) : 0;
      }
      dataObj.today = customerTodayData;

      const returnData = {};
      for (const [item, data] of Object.entries(dataObj)) {
        for (const [customerId, customerOutcomeData] of Object.entries(data)) {
          let foundCustomer = this.customers.find((customerSearch) => {
            return customerSearch.disctools_id == customerId;
          });
          if (returnData[customerId] == undefined) {
            returnData[customerId] = {
              mostRecent: {},
              mostRecentLastWeek: {},
              today: {},
            };
          }
          returnData[customerId][item] = customerOutcomeData;
          returnData[customerId].disctools_id = foundCustomer.disctools_id;
          returnData[customerId].name = foundCustomer.customer_name;
        }
      }

      for (const [key, value] of Object.entries(returnData)) {
        this.tableData.push(value);
      }
      this.loading = false;
    },
    CalculateHourStats(customerStats) {
      const customerReturn = { booked: 0, bookablesessions: 0, fullybooked: 0 };
      for (const [outcome, value] of Object.entries(customerStats)) {
        let outcomeName = outcome.replace(/_/g, "");
        customerReturn[outcomeName.toLowerCase()] = value;
      }
      customerReturn.conversionrate = customerReturn.bookablesessions > 0 ? parseInt((customerReturn.booked / customerReturn.bookablesessions) * 100) : 0;
      return customerReturn;
    },
    classObject(cellValue) {
      return {
        "has-background-info": cellValue > "50" ? true : false,
      };
    },
    GetClassColour(conversionRate1, conversionRate2) {
      if (conversionRate1 > conversionRate2 && conversionRate1 < 50) {
        return "amber";
      } else if (conversionRate1 >= conversionRate2) {
        return "green";
      } else if (conversionRate1 > 50) {
        return "amber";
      } else {
        return "red";
      }
    },
  },
  mounted() {
    this.CalculateTableStats();
  },
};
</script>

<style scoped>
.wrapper {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 20fr;
  max-height: 650px;
}
.title {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2em;
}
.b-table {
  overflow-x: hidden;
}
</style>

<style>
.b-table .table-wrapper.has-sticky-header {
  height: 100%;
  overflow-y: auto;
}
.red {
  color: #ff4949;
}
.green {
  color: limegreen;
}
[data-label="Conversion Rate"] {
  border-right: 1px solid #d0d0d0 !important;
}
span.littleBox {
  padding: 5px 8px;
  color: white;
  font-weight: bold;
  border-radius: 10px;
  cursor: default;
}
.red span.littleBox {
  background-color: #ff6262;
}
.green span.littleBox {
  background-color: #47d061;
}
.amber span.littleBox {
  background-color: #f09e32;
}
.notification {
  border-radius: 7px;
  padding: 0.5rem;
}
</style>
